import { useState } from "react";
import { ApiClientError } from "../../lib/api/client";
import { uploadFile } from "../../lib/api/files";
import { Button } from "../../components/ui/Button";
import { Modal } from "../../components/ui/Modal";

interface AttachEvidenceModalProps {
  open: boolean;
  onClose: () => void;
  expenseId: string;
  expenseReference: string;
  payee: string;
  onUploaded: () => void;
}

export function AttachEvidenceModal({
  open,
  onClose,
  expenseId,
  expenseReference,
  payee,
  onUploaded,
}: AttachEvidenceModalProps) {
  const [error, setError] = useState<string | null>(null);
  const [uploading, setUploading] = useState(false);

  async function save(file: File) {
    setError(null);
    setUploading(true);
    try {
      await uploadFile({
        file,
        entityType: "expense",
        entityId: expenseId,
      });
      onUploaded();
      onClose();
    } catch (err) {
      setError(err instanceof ApiClientError ? err.message : "Could not attach file.");
    } finally {
      setUploading(false);
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Attach supporting evidence"
      description={`${expenseReference} · ${payee}`}
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
        </>
      }
    >
      {error ? <p className="edlab-error mb-4">{error}</p> : null}
      <label className="form-field">
        Supporting file
        <input
          type="file"
          accept=".pdf,.png,.jpg,.jpeg,.webp"
          disabled={uploading}
          className="edlab-input"
          onChange={(event) => {
            const selected = event.target.files?.[0];
            if (selected) {
              void save(selected);
            }
            event.target.value = "";
          }}
        />
        <small className="text-xs text-edlab-muted">PDF, PNG, JPEG or WebP</small>
      </label>
    </Modal>
  );
}
